import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ImpersonateDto} from "../../../models/impersonate-dto";

@Component({
  selector: 'app-logged-in-page-base',
  templateUrl: './logged-in-page-base.component.html',
  styleUrls: ['./logged-in-page-base.component.scss'],
  standalone: false
})
export class LoggedInPageBaseComponent {

  //This page provides the base the for pages that require the user to be logged in
  //Also provides base messaging for success and errors
  showSuccessMessages: boolean = false;
  showPageSuccessMessages: boolean = false;
  showErrorMessages: boolean = false;
  showPageErrorMessages: boolean = false;

  pageSuccessMessages: any[] = [];
  pageErrorMessages: any[] = [];

  constructor(private auth2Service: Auth2Service, private router: Router) {
  }

  showErrorMessagesToUser(delayMs: number = 60000): void {
    this.showErrorMessages = true;
    const counterFn = () => {
      this.showErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageErrorMessagesToUser(delayMs: number = 60000): void {
    this.showPageErrorMessages = true;
    const counterFn = () => {
      this.showPageErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showSuccessMessagesToUser(delayMs: number = 60000): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.showSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageSuccessMessagesToUser(delayMs: number = 60000): void {
    this.showPageSuccessMessages = true;
    const counterFn = () => {
      this.showPageSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  private clearCache(): void{
    localStorage.removeItem('lastSearchGrant');
    localStorage.removeItem('lastSearchGrantExpTime');
    localStorage.removeItem('lastSearchDonor');
    localStorage.removeItem('lastSearchDonorExpTime');
    localStorage.removeItem('lastSearchNonprofit');
    localStorage.removeItem('lastSearchNonprofitExpTime');
    this.auth2Service.removeImpersonatedEmail();
    this.auth2Service.removeConsultantRoleName();
  }

  redirectToLogin(error: any) {
    if (error.status == 401) {
      this.pageErrorMessages.push({
        field: 'User Session Error',
        detail: 'You have logged out due to session being invalid. ' + error.error.message,
        severity: 'error'
      });
      this.showErrorMessagesToUser();
      this.clearCache();
      this.router.navigateByUrl('app/login');
    }
  }

  onExitViewAs(dto: ImpersonateDto): void {
    localStorage.removeItem('impersonatedEmail');
    localStorage.removeItem('consultantRoleName');
    this.router.navigateByUrl('app/consultants/users/account/selection')
  }
  onLogout(): void {
    this.clearCache();
    this.auth2Service.logout().subscribe(
      (result: any) => {
        this.auth2Service.cleanOutSession();
        this.pageSuccessMessages.push({
          field: 'Logout Success',
          detail: 'Successfully logging out.',
          severity: 'success'
        });
        this.showPageErrorMessagesToUser();
        this.router.navigateByUrl('app/logged-out');
      }, (error: HttpErrorResponse) => {
        this.auth2Service.cleanOutSession();
        this.pageErrorMessages.push({
          field: 'Logout Error',
          detail: 'Failed to logout...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.router.navigateByUrl('app/logged-out');
      }
    );
  }
}
